<template>
  <div>
    <slot name="signatureText">
      <p class="bottom-text">
        Upon signing, I testify that all data submitted is correct. I understand
        that all applications become the property of ASCA.
      </p>
      <p>
        I further certify that I was the owner, co-owner, or lessee of the
        sire(s) listed on this application on the date of birth of the litter
        and that this dam was mated only to the sire listed on this application.
      </p>
      <p>
        Should information in this application prove false, applicant will
        indemnify and defend ASCA and hold it harmless against any resulting
        loss. The lineage of your dog can be determined with certainty by DNA
        testing sponsored by ASCA.
      </p>
      <p>
        I further understand that as an owner of an ASCA registered litter, I
        agree to abide by the <ASCAArtIncLink />, <BylawsLink />, and all ASCA Rules and Regulations governing the ASCA Registry,
        Conformation, Obedience and Stock Dog Program and to disciplinary
        action, if necessary, as determined by the ASCA Board of Directors.
      </p>
      <p>
        I hereby certify these dogs have not been registered as another breed.
        In addition, I will not register these dogs as another breed. I
        understand if I register these dogs as another breed, their ASCA
        registration will be revoked.
      </p>
    </slot>
    <v-text-field
      outlined
      v-model="val"
      label="Signature"
      @input="$emit('update', $event)"
    ></v-text-field>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ASCAArtIncLink from "../ASCAArtIncLink.vue";
import BylawsLink from "../BylawsLink.vue";

export default Vue.extend({
  name: "Signature",
  components: { ASCAArtIncLink, BylawsLink },
  data: function () {
    return {
      val: this.signature,
    }
  },
  props: {
    signature: String,
  }
});
</script>